import React from "react";
import { Link } from "react-router-dom";

import { MdOutlineAdminPanelSettings, MdPhoneInTalk } from "react-icons/md";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { useGetBlogsQuery } from "../../products/productSlice";

import blog1 from "../../../assets/img/blog/WA0045.jpg";
import blog2 from "../../../assets/img/blog/WA0046.jpg";
import blog3 from "../../../assets/img/blog/WA0047.jpg";
import blog4 from "../../../assets/img/blog/WA0048.jpg";

const cosmeticBlogCategories = [
  {
    id: 1,
    url: blog1,
    name: "Transform Your Outdoor Space: Expert Landscaping Tips & Ideas",
    description: "Your outdoor space is the first impression your home makes—so why not make it unforgettable? Landscaping isn’t just about planting a few flowers or mowing the lawn. It's about creating a cohesive, beautiful environment that enhances the look and feel of your property. Whether you're working with a sprawling backyard or a compact front garden, the right landscaping can completely transform your space."
  },
  {
    id: 2,
    url: blog2,
    name: "Landscaping Inspiration for Every Season",
    description: "Start by defining how you want to use your outdoor area. Do you envision a relaxing patio, a vibrant flower garden, or a space for entertaining guests? Planning with purpose helps guide your design choices, from selecting the right plants to choosing the best hardscape elements like walkways, decks, or retaining walls. Think of your yard as an extension of your home—it should reflect your personality and lifestyle."
  },
  {
    id: 3,    
    url: blog3,
    name: "Simple Landscaping Upgrades That Wow",
    description: "One of the most impactful ways to upgrade your landscaping is through layering and texture. Use a variety of plants—trees, shrubs, perennials, and ground covers—to create depth and visual interest. Incorporate stone, wood, or gravel elements for contrast, and don’t forget lighting! Well-placed outdoor lighting not only adds ambiance but also improves safety and functionality after dark."
  },
  {
    id: 4,
    url: blog4,
    name: "The Ultimate Guide to Modern Landscaping Design",
    description: "Finally, maintenance is key to long-term success. Choose plants suited to your climate and soil to reduce upkeep. Invest in a simple irrigation system to keep things green without extra effort. And remember: great landscaping doesn’t have to happen all at once. Start with small changes, and let your outdoor space evolve with your vision and budget."
  },
  
];
function BlogItem() {
  const { data, isLoading } = useGetBlogsQuery();
  return (
    <>
      <section className="blogItemSec">
        <div className="row">
          {isLoading && (
            <div className="preloaderCount">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          {cosmeticBlogCategories.map((item) => {
            return (
              <div key={item.id} className="col-lg-6">
                <div
                  className="blogItemInfo brochuresItems"
                  
                >
                  <div className="eventFigure">
                    <Link to={`/blog-detail/${item.id}`}><img src={item.url} alt="Blog" /></Link>
                    <div className="postDate">
                      <span className="date">25</span>
                      <span className="month">feb</span>
                    </div>
                  </div>
                  <div className="eventContent">
                    

                    <h5>
                      {/* <Link to={`/blog-detail/${item.uid}/${item.slug}`}> */}
                      <Link to={`/blog-detail/${item.id}`}>{item.name}</Link>
                    </h5>
                    <div className="blogItemContent d-none">
                      <div className="author">
                        <ul>
                          <li>
                            {/* <Link to={`/blog-detail/${item.uid}/${item.slug}`}> */}
                            <Link to={`/blog-detail/${item.id}`}>
                              <MdOutlineAdminPanelSettings />
                              By Ismail
                            </Link>
                          </li>
                          <li>
                            {/* <Link to={`/blog-detail/${item.uid}/${item.slug}}`}> */}
                            <Link to={`/blog-detail/${item.id}`}>
                              {" "}
                              <MdPhoneInTalk /> Consulting
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          {/* {data &&
            data.map((item) => {
              return (
                <div key={item._id} className="col-lg-6">
                  <div className="blogItemInfo">
                    <div className="blogItemFigure">
                      <img
                        src={item.banner.url}
                        style={{ height: "400px" }}
                        alt="Blog"
                      />
                      <div className="postDate">
                        <span className="date">25</span>
                        <span className="month">feb</span>
                      </div>
                    </div>
                    <div className="blogItemContent">
                      <div className="author">
                        <ul>
                          <li>
                            <Link to={`/blog-detail/${item.uid}/${item.slug}`}>
                              <MdOutlineAdminPanelSettings />
                              By Ismail
                            </Link>
                          </li>
                          <li>
                            <Link to={`/blog-detail/${item.uid}/${item.slug}}`}>
                              {" "}
                              <MdPhoneInTalk /> Consulting
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="title">
                        <h4>
                          <Link to={`/blog-detail/${item.uid}/${item.slug}`}>
                            {item.title}
                          </Link>
                        </h4>
                        <p>{item.short_description}</p>
                      </div>
                      <div className="readMore">
                        <Link to={`/blog-detail/${item.uid}/${item.slug}`}>
                          Read More <HiOutlineArrowNarrowRight />{" "}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })} */}
        </div>
      </section>
    </>
  );
}

export default BlogItem;
